import React from 'react'
import actions from '../reducers/actions'
import { connect } from 'react-redux'
import Faq from '../components/Faq'
import Video from '../components/Video'
import Navigation from '../components/Navigation'

function FaqPage(props) {
  const { user, logout, endImpersonation } = props

  return (
    <div>
      <Navigation logout={() => logout(user)} user={user} endImpersonation={endImpersonation} />
      <div style={{ marginTop: 75, padding: 10 }}>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Video />
        </div>
        <Faq />
      </div>
    </div>
  )
}

const mapStateToProps = (state, ownProps) => {
  return { ...state, ...ownProps }
}

export default connect(mapStateToProps, actions)(FaqPage)